<template>
    <v-container>
        <!--
        <v-app-bar color="deep-purple accent-4" dense dark>
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
            <v-toolbar-title>萬來屋</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
                <v-icon>mdi-heart</v-icon>
            </v-btn>
        </v-app-bar>
        -->

        <div class="my-13 pl-13">
            <h2>萬來屋</h2>
            <h5 class="grey--text">ポスティング配布サービス</h5>
        </div>

        <v-img class="align-center" height="150px" src="/img/sky.jpg"></v-img>

        <v-footer color="grey darken-4" padless>
            <v-row justify="center" no-gutters>
                <v-btn text rounded class="white--text font-weight-bold" @click="page = 1">ホーム</v-btn>
                <v-btn text rounded class="white--text font-weight-bold" @click="page = 2">ご依頼手順</v-btn>
                <v-btn text rounded class="white--text font-weight-bold" @click="page = 3">サービスの流れ</v-btn>
                <v-btn text rounded class="white--text font-weight-bold" @click="page = 4">サービス一覧</v-btn>
                <v-btn text rounded class="white--text font-weight-bold" @click="page = 5">ポリシー</v-btn>
            </v-row>
        </v-footer>

        <div class="ma-5" v-show="page == 4">
            <h1>【サービス一覧】</h1>
            <v-card class="mt-5 pa-5" color="grey lighten-3">
                <h4>・指定エリア配布</h4>
                <div class="ml-5">(弊社のサービスエリア内のご指定地域へ)</div>

                <h4 class="mt-5">・指定物件配布</h4>
                <div class="ml-5">(戸建・集合住宅など)</div>

                <h4 class="mt-5">・期日指定</h4>
                <div class="ml-5">(定期配布クライアント様優先の為、事前にご相談くださいませ)</div>
            </v-card>
        </div>

        <div class="ma-5" v-show="page == 3">
            <h1>【サービスの流れ】</h1>
            <v-card class="mt-5 pa-5" color="grey lighten-3">
                <h4>1：ご相談</h4>
                <div class="ml-5">御社のご希望をお伺いし、最良のご提案を差し上げます。</div>

                <h4 class="mt-5">2：ご商材納入（配布物）</h4>
                <div class="ml-5">弊社事務所へ直送お願いします。</div>

                <h4 class="mt-5">3：ご入金</h4>
                <div class="ml-5">ご入金が確認でき次第、配布を実施します。</div>
                <div class="ml-5">※お取引状況で掛売もご利用いただけるようになります。</div>

                <h4 class="mt-5">4：配布実施</h4>
                <div class="ml-5">事前にお約束させて頂いたサイクルで配布状況の報告を行います。</div>

                <h4 class="mt-5">5：配布報告</h4>
                <div class="ml-5">配布完了次第、速やかに完了報告を行います。</div>
            </v-card>
        </div>

        <div class="ma-5" v-show="page == 2">
            <h1>【ご依頼手順】</h1>
            <v-card class="mt-5 pa-5" color="grey lighten-3">
                <h4>下記項目をもれなく記入し「 tsa.japan.inc@gmail.com 」にご連絡ください。</h4>
                <v-textarea outlined :value="mailSample" height="320" readonly></v-textarea>
                <h4>※県内および隣接府県へはご出張での面談も行っております。</h4>
            </v-card>
        </div>

        <div class="ma-5" v-show="page == 5">
            <h1>【ポリシー】</h1>
            <v-card class="mt-5 pa-5" color="grey lighten-3">
                <p>・クライアント様とのお約束は必ず守ります。</p>
                <p>・クライアント様から託された広告は責任をもって取り扱います。</p>
                <p>・確実な業務遂行のため、無理なスケジュールは組みません。</p>
                <p>・予約状況などで実施不可能な場合は事前にお断りします。</p>
                <p>・金融業・風俗・その他青少年に悪影響を与える類の広告は引受不可。</p>
                <p>・公序良俗に反するおそれのある広告類はお引受けできません。</p>
            </v-card>
        </div>

        <div class="ma-5" v-show="page == 1">
            <h1>【会社情報】</h1>
            <v-card class="mt-5 pa-5" color="grey lighten-3">
                <div class="text-decoration-underline font-weight-bold">◆名称</div>
                <div>ティーエスエー萬來屋（ばんらいや）</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆創業</div>
                <div>平成19年1月15日</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆本社所在地</div>
                <div>〒516-0072</div>
                <div>三重県伊勢市宮後1-7-4 伊東ﾋﾞﾙﾃﾞｨﾝｸﾞ2F</div>
                <div>TEL : 0596-23-0255</div>
                <div>FAX : 0596-23-0275</div>
                <div>MAIL : tsa.japan.inc@gmail.com</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆事業内容</div>
                <div>・各種広告商材、出版物などのダイレクトポスティング</div>
                <div>・各種セールスプロモーションプランニング、マネージメント</div>
                <div>・ポスティングツール、販促物の企画、制作</div>
                <div>・HP企画、制作</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆社訓</div>
                <div>Do the little thing</div>
                <div>細かいことを疎かにしない</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆活動理念</div>
                <div>ポスティングを通じて地域の皆様に正確で役立つ情報提供を行うとともにクライアントの皆様に対してのレスポンスを真に追求し、その業績アップに貢献する。</div>
                <div>法令を遵守し、社会規範、倫理観に則した業界最高水準のマナーとサービス推進のために、全スタッフ一人一人が日々自己研鑽を怠りません。</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆基本営業範囲</div>
                <div>三重県中南部を中心に行っております。</div>
                <div>それ以外の地域はご相談ください。</div>

                <div class="text-decoration-underline font-weight-bold mt-5">◆PRポイント</div>
                <div>・地の利を活かせ、クレームを未然に防ぐ為、ご当地地域担当者優先方式を行っています。</div>
                <div>・広いターゲットへの大量告知型から見込み客を絞り込む集中型まで常にクライアント様の商圏、ターゲット層に効果的な販促活動が行えるためのデータ収集を行っております。</div>
                <div>・配布地域、居住形態、ターゲット層の細分化など、入念な打ち合わせを実施します。</div>
                <div>・クライアント様の自社スタッフになった強い気持ちで配布活動を遂行します。</div>
            </v-card>
        </div>
    </v-container>
</template>

<script>
export default {
    name: "Home",
    components: {},
    data() {
        return {
            titleList: ["会社情報", "ご依頼手順", "サービスの流れ", "サービス一覧", "ポリシー"],
            page: 1,
            mailSample:
                "・御社名 : (例 : 株式会社ティーエスエー) \n" +
                "・担当者様名 : (例 : 萬來太郎) \n" +
                "・業種 : (例 : 住宅建設販売業) \n" +
                "・御社住所 : (例 : 〒516-0072 三重県伊勢市宮後1-7-4 伊東ビル2F-A) \n" +
                "・お電話番号 : (ご連絡先） (例 : 0596-23-0255) \n" +
                "・配布希望期間 : (例 : 2008年3月1日〜3月30日) \n" +
                "・配布希望枚数 : (例 : 30,000部) \n" +
                "・配布希望エリア : (例 : 伊勢・松阪全域) \n" +
                "・配布希望居住形態 : (例 : 集合住宅のみ／戸建のみ／集合住宅・戸建すべて) \n" +
                "・その他ご要望 : (例 : 電話にて詳細を相談したい／弊社（萬來屋）に訪問したい／訪問してほしい) \n",
        };
    },
};
</script>
